import { StyleCompiler } from '@angular/compiler/src/style_compiler';
import { Component, Input, style } from '@angular/core';

@Component({
    selector: 'async-content',
    styles: [require('./async-content.component.scss')],
    template: `
        <div class="async-content">
            <div class="background" [style.background-color]="backgroundColor" [style.opacity]="opacity" [class.hidden]="!busy"></div>
            <div class="preloader-container" [class.hidden]="!busy">
                <div class="layout-column layout-align-center-center h-100">
                    <div class="flex-nogrow">{{message}}</div>
                </div>
            </div>
            <div [class.hidden]="busy" class="animated fadeIn">
                <ng-content></ng-content>
            </div>
        </div>
    `,
})
export class AsyncContentComponent {
    @Input() busy = false;
    @Input() backgroundColor = 'black';
    @Input() opacity = 0.8;
    @Input() loaderColor = '#E41736';
    @Input() message = 'Loading ...';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/async-content/async-content.component.ts